module.exports = __webpack_public_path__ + "static/white-logo-ed4030b1d5b49d3e77e37176041ceae0.svg";